import { Component, OnInit } from '@angular/core';
import {FormBuilderService} from '../shared/services/databaseServices/formBuilderService/form-builder.service';
import {EditService} from '../shared/services/editService/edit.service';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {Router} from '@angular/router';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {Form} from '../shared/classes/Form';

@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.css']
})
export class FormBuilderComponent implements OnInit {

  forms: Form[] = undefined;
  faPlus = faPlus;
  urlPrefix = '';
  displayedColumns: string[] = ['url', 'race'];

  header = [
    {
      defName: 'url',
      translation: 'settingPage.formBuilder.formBuilder.url',
      elem: 'url'
    },
    {
      defName: 'race',
      translation: 'settingPage.formBuilder.formBuilder.race',
      elem: 'race'
    }
  ];

  constructor(private formBuilderService: FormBuilderService,
              private formsService: FormsService,
              private editService: EditService,
              private router: Router) { }

  ngOnInit() {
    this.setPrefixUrl();
    this.formsService.getForms().then( data => {
      this.forms = [];
      data.forEach( item => {
        const form = new Form();
        form.key = item.id;
        form.url = `${this.urlPrefix}/showForm/${item.data().url}`;
        form.formItems = item.data().formItems;
        form.race = item.data().race;
        this.forms.push(form);
      });
      this.forms = this.forms.map(item => {
        if (item.race !== undefined) {
          item.race.get().then(race => {
            item.raceData = race.data();
            item.race = item.raceData.name;
            return item;
          });
        }
        return item;
      });
    });
  }

  private setPrefixUrl(){

    this.urlPrefix = location.href;
    const protocol = this.urlPrefix.substr(0, this.urlPrefix.indexOf(':'));
    this.urlPrefix = this.urlPrefix.substr(this.urlPrefix.indexOf(':') + 3);
    this.urlPrefix = `${protocol}://${this.urlPrefix.substr(0, this.urlPrefix.indexOf('/'))}`;
  }

  public create() {
    this.router.navigate(['/admin/settings/forms', 'new']);
  }

  public isEdit(): boolean{
    return this.editService.editable;
  }

  public edit(item) {
    this.router.navigate(['/admin/settings/forms', item.key ]);
  }

  openUrl(){
  }

}
